<template>
  <div class="login-page-container">
    <div class="login-page-wrapper">
      <login />
    </div>
  </div>
</template>

<script>
import Login from "../components/Login";
export default {
  name: "LoginPage",
  components: {Login}
}
</script>

<style lang="scss" scoped>
.login-page-container {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  background-color: #024089;
  height: 100vh;
  width: 100vw;

  .login-page-wrapper {
    height: 100%;
    width: 100%;
  }
}
</style>
